import React from 'react'
import { IconType } from 'react-icons'
import { Center } from '@chakra-ui/react'
import { Icon, type IconProps } from '@chakra-ui/icons'
import { Tooltip, type TooltipProps } from '@chakra-ui/react'
import { CenterProps } from '@chakra-ui/react'

interface Props extends IconProps {
    label: React.ReactNode
    icon: IconType
    tooltipOverrides?: Omit<TooltipProps, 'children'>
    centerOverrides?: CenterProps
}

export default function IconWithTooltip({
    label,
    icon,
    tooltipOverrides,
    centerOverrides,
    ...rest
}: Props) {
    return (
        <Tooltip
            hasArrow
            label={label}
            bg="white"
            borderColor="blackAlpha.200"
            borderWidth={1}
            fontSize="12px"
            color="gray.700"
            rounded="lg"
            {...tooltipOverrides}
        >
            <Center {...centerOverrides}>
                <Icon as={icon} {...rest} />
            </Center>
        </Tooltip>
    )
}
